<template>
  <span class="ai-agent-conversations-item__title">
    {{ conversation.title }}
  </span>
  <UIDropdownActions :data>
    <template #default="{ toggle }">
      <EllipsisHorizontalIcon class="ai-agent-conversations-item__menu" @click.stop.prevent="toggle" />
    </template>
  </UIDropdownActions>
</template>

<script setup lang="ts">
import { computed, markRaw } from 'vue'

import { AIConversation } from '@types'

import { useModalsStore } from '@/store/modals'

import { UIDropdownActions } from '@ui/dropdowns'
import { UIDialogRemove } from '@ui/modals'
import { EllipsisHorizontalIcon, TrashIcon } from '@heroicons/vue/24/outline'

type Props = {
  conversation: AIConversation
}

type Emits = {
  'click:delete': [data: string]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const modalsStore = useModalsStore()

const data = computed(() => [
  {
    label: 'Delete',
    icon: TrashIcon,
    action: (hide: () => void) => {
      hide()
      const modalInstance = modalsStore.init(
        'ai-agent-remove-conversation',
        markRaw(UIDialogRemove),
      )
      modalInstance?.open(modalsStore.getZIndex(), {
        title: `Delete chat '${props.conversation.title}'`,
        message: 'Are you sure you want to delete this chat?',
        label: 'Delete',
        onRemove: handleDelete,
      })
    },
  },
])

const handleDelete = () => {
  emit('click:delete', props.conversation.thread_id)
}
</script>

<style>
.ai-agent-conversations-item {

  &__title {
    @apply flex-auto truncate text-left;
  }

  &__menu {
    @apply size-4;
  }
}
</style>
